import { useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Types from './components/Types';
import Chassis from './components/Chassis';
import Yard from './components/Yard';
import Column from './components/Column';
import Company from './components/Company';
import Footer from './components/Footer';
import Contact from './components/Contact';
import FloatingCTA from './components/FloatingCTA';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import ColumnDetail from './components/ColumnDetail.jsx';
import ContainerDetail from './components/ContainerDetail.jsx';
import ChassisDetail from './components/ChassisDetail.jsx';
import useScrollReveal from './hooks/useScrollReveal';

function ScrollToHash() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (!hash) return;

    const targetId = hash.replace('#', '');
    let frameId;
    let timeoutId;

    const scrollToTarget = () => {
      const target = document.getElementById(targetId);

      if (target) {
        target.scrollIntoView({ block: 'start' });
      }
    };

    frameId = window.requestAnimationFrame(scrollToTarget);
    timeoutId = window.setTimeout(scrollToTarget, 120);

    return () => {
      window.cancelAnimationFrame(frameId);
      window.clearTimeout(timeoutId);
    };
  }, [hash, pathname]);

  return null;
}

function App() {
  useScrollReveal();

  return (
    <BrowserRouter>
      <ScrollToHash />
      <Routes>

        <Route
          path="/"
          element={
            <main>
              <Header />
              <Hero />
              <Types />
              <About />
              <Chassis />
              <Yard />
              <Column />
              <Company />
              <Contact />
              <Footer />
              <FloatingCTA />
            </main>
          }
        />

        <Route
          path="/column/:id"
          element={<ColumnDetail />}
        />

        <Route
          path="/containers/:slug"
          element={<ContainerDetail />}
        />

        <Route
          path="/chassis"
          element={<ChassisDetail />}
        />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
